<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Channel List</h5>
                </div>
                <div class="card-body">
                    <div class="btn-popup pull-right">
                    </div>
                    <div class="custom-datatable">
                        <form [formGroup]="EditChannels">
                            <div class="mb-3">
                                <!-- <input type='text' class="filter-ngx form-control" placeholder='Search...' [(ngModel)]="searchText"
                                  autocomplete="off" /> -->
                                <button class="btn btn-primary me-1 mb-3" style="float: right;"
                                        (click)="moveToMainPage()">Back
                                </button>

                                <label>country<span class="text-danger">*</span></label>
                                <select class="form-select form-control" formControlName="countryname">
                                    <option *ngFor="let item of countryname"
                                            [ngValue]="item.country_id">{{item.country_name}}</option>
                                </select>

                                <label>language<span class="text-danger">*</span></label>
                                <select class="form-select form-control" formControlName="languagename">
                                    <option *ngFor="let item of language"
                                            [ngValue]="item.language_id">{{item.language_name}}</option>
                                </select>

                                <label>ownedtype<span class="text-danger">*</span></label>
                                <select class="form-select form-control" formControlName="owned">
                                    <option [ngValue]="1">Owned</option>
                                    <option [ngValue]="0">NotOwned</option>
                                    <option *ngFor="let item of channels"
                                            [ngValue]="item.id">{{item.owned_name}}</option>
                                </select>

                                <label>Scrape Users From Messages<span class="text-danger">*</span></label>
                                <select class="form-select form-control" formControlName="watch_messages_for_scrapping_user">
                                    <option [ngValue]="1">Yes</option>
                                    <option [ngValue]="0">No</option>
                                    <option *ngFor="let item of channels"
                                            [ngValue]="item.watch_messages_for_scrapping_user">{{item.watch_messages_for_scrapping_user}}</option>
                                </select>
                                <label>Message with Image<span class="text-danger">*</span></label>
                                <select class="form-select form-control" formControlName="message_with_image">
                                    <option [ngValue]="1">Yes</option>
                                    <option [ngValue]="0">No</option>
                                    <option *ngFor="let item of channels"
                                            [ngValue]="item.message_with_image">{{item.message_with_image}}</option>
                                </select>

                            </div>
                        </form>
                        <button class="btn btn-primary me-1 mb-3" style="float: right;" (click)="updateChannels()">
                            Save
                        </button>
                        <div class="clearfix"></div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
